<template>
    <div>
        <breadCrumb
            :icon="'fa-info-circle'"
            :category="$t(`sideNav.navSalonSetting`)"
            :subCategory="$t(`subMenu.salon_setting_landing`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 pb-4">
                    <div class="row w-100">
                        <div class="col-sm-12 col-md-4">
                            <div class="form-group d-flex">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false"
                                        :show-labels="false" openDirection="below" @select="filterByOutlet">
                                        <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <ul class="nav nav-tabs mb-5" role="tablist">
                            <li class="nav-item" v-for="infoTab in $i18n.messages[$i18n.locale].tab.landingTabs" :key="infoTab.id">
                                <a :class="{ 'active': selectedTab == infoTab.id }" class="nav-link" role="tab"
                                    @click="selectedTab = infoTab.id">{{ infoTab.text }}</a>
                            </li>
                        </ul>
                        <div class="tab-content mt-5">
                            <landing ref="landing" :class="{ 'active': selectedTab == 'landing' }" class="tab-pane" @submitInfo="submitInfo"></landing>
                            <deposit ref="deposit" :class="{ 'active': selectedTab == 'deposit' }" class="tab-pane" :banks="banks" @submitDeposit="submitDeposit"></deposit>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'

import Landing from './Landing_Landing'
import Deposit from './Landing_Deposit'

export default {
    name: 'info',
    components: {
        BreadCrumb, Landing, Deposit
    },
    data() {
        return {
            selectedTab: "landing",

            outlet: [],
            selectedOutlet: {},
            banks: [],

            info: {},
            deposit: {},
        }
    },
    methods: {
        closeModal(isError) {
            if (!isError) {
                this.selectedTab = 'landing'
                this.getInfo();
                this.getDeposit();
            }
            this.$parent.isModalShow = false;
        },
        filterByOutlet(item) {
            this.selectedOutlet = item;
            this.getInfo();
            this.getDeposit();
        },

        getBank() {
            const url = `https://bebusiness.tunai.io/banks`

            let $vm = this;
            $vm.$axios({
                method: 'get',
                url: url,
                baseURL: $vm.$axios.defaults.baseURL,
                headers: { token: $vm.$session.get('token') }
            })
                .then((response) => {
                    this.banks = response.data.bank
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
        getInfo() {
            let $vm = this;

            // const url = this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.INFO
            const url = `https://bebusiness.tunai.io/outlet/`

            $vm.$axios({
                method: 'get',
                url: url,
                baseURL: $vm.$axios.defaults.baseURL,
                headers: { token: $vm.$session.get('token') }
            })
                .then((response) => {
                    $vm.info = (response.data.find(k => k['outletID'] === this.selectedOutlet.id) || {})['landing'];
                    this.$refs['landing'].setInfo($vm.info)
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
        getDeposit() {
            let $vm = this;
            
            // const url = $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.INFO
            const url = `https://bebusiness.tunai.io/outlet/${this.selectedOutlet.id}/deposit`

            $vm.$axios({
                method: 'get',
                url: url,
                baseURL: $vm.$axios.defaults.baseURL,
                headers: { token: $vm.$session.get('token') }
            })
                .then((response) => {
                    $vm.deposit = response.data[0] || {};
                    this.$refs['deposit'].setDeposit($vm.deposit)
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        submitInfo(item) {
            var data = Object.assign(this.info, item);

            const url = `https://bebusiness.tunai.io/outlet/${this.selectedOutlet.id}/landing`

            let $vm = this
            $vm.$axios({
                method: 'post',
                url: url,
                baseURL: $vm.$axios.defaults.baseURL,
                headers: { token: $vm.$session.get('token') },
                data: data,
            })
                .then((response) => {
                    if (response.status == 200) {
                        var message = $vm.$i18n.t('subMenu.salon_setting_landing') + $vm.$i18n.t('message.success.success', { 'action': $vm.$i18n.t('message.success.action.update') })
                        $vm.$parent.setModal($vm, false, true, message);
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
        submitDeposit(item) {
            var data = Object.assign(this.deposit, item);

            const url = `https://bebusiness.tunai.io/outlet/${this.selectedOutlet.id}/deposit`
            let $vm = this
            $vm.$axios({
                method: 'post',
                url: url,
                baseURL: $vm.$axios.defaults.baseURL,
                headers: { token: $vm.$session.get('token') },
                data: data,
            })
                .then((response) => {
                    if (response.status == 200) {
                        var message = 'Deposit setting ' + $vm.$i18n.t('message.success.success', { 'action': $vm.$i18n.t('message.success.action.update') })
                        $vm.$parent.setModal($vm, false, true, message);
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
    },
    mounted() {
        this.outlet = JSON.parse(this.$store.state.outlets);
        this.selectedOutlet = this.outlet[0];

        this.getBank();
        this.getInfo();
        this.getDeposit();
    }
}
</script>
<style scoped>
.nav-link {
    cursor: pointer;
}

.show {
    display: block;
}</style>